export default "__VITE_ASSET__B9mgslf8__"